import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { dateOptionsCriteria, organisationTabCriteria, boundariesCriteria } from '../../../utilities/epic-helpers';

import {
  FETCH_TRAVEL_PAST_DAILY_AVERAGES,
  FETCH_TRAVEL_PAST_DAILY_AVERAGES_ERROR,
  SET_TRAVEL_PAST_DAILY_AVERAGES,
} from '../../constants';

const travelPastDailyAverages = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_TRAVEL_PAST_DAILY_AVERAGES),
    switchMap(() =>
      ajax({
        url: `${
          state$.value.auth.server
          }/report/travel-past/daily-averages?${
          dateOptionsCriteria(state$, 'travelPast')
          }${
          organisationTabCriteria(state$)
          }${
          boundariesCriteria(state$)
          }${
          state$.value.travelPast.averageFilter
            ? `&average_filter=${encodeURIComponent(
              state$.value.travelPast.averageFilter
            )}`
            : ''
          }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {

          return {
            type: SET_TRAVEL_PAST_DAILY_AVERAGES,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_TRAVEL_PAST_DAILY_AVERAGES_ERROR,
            error,
          })
        )
      )
    )
  );

export default travelPastDailyAverages;
